var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { UserService } from '@/domains/user/services/user-service.interface';
let TimezoneServiceImpl = class TimezoneServiceImpl {
    constructor(_userService) {
        this._userService = _userService;
    }
    _getUtcOffset() {
        const utc_offset = this._getUserSettingUtcOffset();
        if (utc_offset[0] !== '-' && utc_offset[0] !== '+') {
            return `+${utc_offset}`;
        }
        return utc_offset;
    }
    _getUserSettingUtcOffset() {
        const utc_offset = this._userService?.userSetting?.time_zone?.utc_offset;
        return utc_offset || this._getBrowserUtcOffset();
    }
    _getBrowserUtcOffset() {
        const offset = new Date().getTimezoneOffset();
        const hours = Math.abs(Math.floor(offset / 60));
        const minutes = Math.abs(offset % 60);
        const padStart = (value, length, padString) => value.toString().padStart(length, padString);
        return `${offset < 0 ? '+' : '-'}${padStart(hours, 2, '0')}:${padStart(minutes, 2, '0')}`;
    }
    getUtcOffsetInHours() {
        const utc_offset = this._getUserSettingUtcOffset();
        const [sHours, sMinutes] = utc_offset.split(':');
        const hours = parseInt(sHours, 10);
        const minutes = parseInt(sMinutes, 10);
        return -(hours + minutes / 60);
    }
    transformToTimeZoneTimestamp(date, timezone) {
        if (!(date instanceof Date)) {
            throw new Error('第 1 个参数必须传入 Date 类型');
        }
        if (timezone === undefined) {
            return this._transformToTimeZone(date);
        }
        if (typeof timezone !== 'number' || timezone < -12 || timezone > 12) {
            throw new Error('第 2 个参数必须传入 -12 到 12 之间的数');
        }
        return this._transformToTimeZone(date);
    }
    _padStart(value, length, padString) {
        return value.toString().padStart(length, padString);
    }
    _transformToTimeZone(selectedDate) {
        const year = selectedDate.getFullYear();
        const month = this._padStart(selectedDate.getMonth() + 1, 2, '0');
        const day = this._padStart(selectedDate.getDate(), 2, '0');
        const hour = this._padStart(selectedDate.getHours(), 2, '0');
        const minute = this._padStart(selectedDate.getMinutes(), 2, '0');
        const second = this._padStart(selectedDate.getSeconds(), 2, '0');
        const dateString = `${year}-${month}-${day}T${hour}:${minute}:${second}${this._getUtcOffset()}`;
        const date = new Date(dateString);
        return date.getTime();
    }
};
TimezoneServiceImpl = __decorate([
    injectable(),
    __param(0, inject(UserService)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserService !== "undefined" && UserService) === "function" ? _a : Object])
], TimezoneServiceImpl);
export { TimezoneServiceImpl };
